// AdSense Configuration
// Instructions:
// 1. Go to your Google AdSense account (https://adsense.google.com)
// 2. Navigate to Ads > By ad unit
// 3. Create a new "Display ad" unit (or use existing)
// 4. Copy your publisher ID (looks like: ca-pub-1234567890123456)
// 5. Copy your ad slot ID (looks like: 9876543210)
// 6. Replace the values below
// 7. Set SHOW_PLACEHOLDER to false to display real ads

export const ADSENSE_CONFIG = {
  // Your AdSense Publisher ID (found in AdSense dashboard)
  // Format: ca-pub-XXXXXXXXXXXXXXXXX
  CLIENT_ID: 'ca-pub-6417299414945681',

  // Your Ad Slot ID (create one in AdSense dashboard)
  // Format: YYYYYYYYYY (numeric)
  AD_SLOT: '1652970976',

  // Set to false once you've added your real AdSense IDs above
  SHOW_PLACEHOLDER: false,  // Set to false to show real ads

  // How often to show ads (every N phone cards)
  AD_FREQUENCY: 3
};

// NOTE: After updating this file, also update the same CLIENT_ID in:
// - public/index.html (line 16)
